'use strict';

var contentProvider = require('./content.provider'),
    mainPanel = null;


module.exports = {
    renders: {
        listItem: require('./renders/list.item'),
        popupSelect: require('./renders/popup.select'),
        popupLayoutList: require('./renders/popup.layout.list'),
        rangeInput: require('./renders/range.input'),
        toggle: require('./renders/toggle'),
        confirm: require('./renders/confirm'),
        input: require('./renders/input'),
        checkbox: require('./renders/checkbox')
    },
    actions: {
        setInfo: require('../components/page.main/right.panel').setInfo,
        applyTheme: function ( themePath ) {
            var themeCss = document.querySelectorAll('[rel="stylesheet"]')[1];

            console.log(themePath + '/' + window.screen.height + '.css');
            themeCss.href = themePath + '/' + window.screen.height + '.css';
        },
        view: {
            reset: function () {
                if ( mainPanel === null ) {
                    mainPanel = require('../components/page.main/main.panel');
                }

                mainPanel.reset();
            },
            refresh: function () {
                if ( mainPanel === null ) {
                    mainPanel = require('../components/page.main/main.panel');
                }

                mainPanel.refresh();
            },
            init: function ( config ) {
                if ( mainPanel === null ) {
                    mainPanel = require('../components/page.main/main.panel');
                }

                mainPanel.init(config);
            }
        }
    },
    getters: {

    },
    savers: {
    },
    sections: {
        add: function ( data ) {
            contentProvider.addSections(data);
        },
        remove: function ( sectionId ) {
            contentProvider.removeSections(sectionId);
        }
    },
    options: {
        add: function ( data ) {
            contentProvider.addOptions(data);
        },
        remove: function ( data ) {
            contentProvider.removeOptions(data);
        }
    },
    content: {
        add: function ( data ) {
            contentProvider.addContent(data);
        },
        remove: function ( data ) {
            contentProvider.removeContent(data);
        }
    }
};
